import type { LoginResponse, MeResponse } from '@/types/api';
import { apiRequest } from './apiClient';
import { csrfStore } from './csrfStore';

export async function login(email: string, password: string): Promise<LoginResponse> {
  const data = await apiRequest<LoginResponse>('/api/auth/login', {
    method: 'POST',
    body: { email, password },
    skipCsrf: true,
  });
  csrfStore.set(data.csrf_token);
  return data;
}

export async function me(opts: { silent?: boolean } = {}): Promise<MeResponse> {
  const data = await apiRequest<MeResponse>('/api/auth/me', {
    silentUnauthorized: opts.silent,
  });
  if (data.csrf_token) csrfStore.set(data.csrf_token);
  return data;
}

export async function logout(): Promise<void> {
  try {
    await apiRequest<void>('/api/auth/logout', { method: 'POST' });
  } finally {
    csrfStore.clear();
  }
}
